(() => {
  const init = scope => {
    scope.querySelectorAll?.('[data-pf-care]').forEach(section => {
      if (section.dataset.ready === 'true') return;
      section.dataset.ready = 'true';
      const tabs = [...section.querySelectorAll('[data-pf-tab]')];
      const panels = [...section.querySelectorAll('[data-pf-panel]')];
      const activate = id => {
        tabs.forEach(tab => {
          const selected = tab.dataset.pfTab === id;
          tab.classList.toggle('is-active', selected);
          tab.setAttribute('aria-selected', selected ? 'true' : 'false');
          tab.tabIndex = selected ? 0 : -1;
        });
        panels.forEach(panel => {
          const selected = panel.dataset.pfPanel === id;
          panel.classList.toggle('is-active', selected);
          panel.hidden = !selected;
        });
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activate(tab.dataset.pfTab));
        tab.addEventListener('keydown', event => {
          if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
          event.preventDefault();
          const offset = event.key === 'ArrowRight' ? 1 : -1;
          tabs[(index + offset + tabs.length) % tabs.length].focus();
        });
      });
      if (tabs[0]) activate(tabs[0].dataset.pfTab);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
